import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Project} from "../models/project";
import {Sort} from "../models/sort";
import {SortHelper} from "../utils/sort-helper";
import {environment} from "../../environments/environment";
import {Assignment} from "../models/assignment";
import {ProjectRole} from "../enum/project-role";

@Injectable({
  providedIn: 'root'
})
export class AssignmentService {
  constructor(private httpClient: HttpClient) { }

  list(project: Project) {
    return this.httpClient.get<Assignment[]>(`${environment.api}/api/v1/assignments/projects/${project.id}`);
  }

  invite(project: Project, email: string, role: ProjectRole) {
    return this.httpClient.post<Assignment>(`${environment.api}/api/v1/assignments/projects/${project.id}`, { email, role });
  }

  delete(assignee: Assignment) {
    return this.httpClient.delete(`${environment.api}/api/v1/assignments/${assignee.id}`);
  }
}
